import request from '@/utils/request'
// const _url = 'https://www.easy-mock.com/mock/5cdcc62a04e0fa1b944ef0a9/admin/ua'
const _url = 'v2/ua'
// 获取列表详情
export function getUaList(params) {
  return request({
    url: _url + '/list',
    method: 'get',
    params
  })
}
// 提交修改详情
// setUaParser
export function setUaParser(data) {
  return request({
    url: _url + '/setUaParser',
    method: 'post',
    data: data
  })
}
